import HeroPost from './HeroPost'

export default HeroPost
